import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import Nav from "@/components/Nav";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [aid, setAid] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) { nav("/"); return; }
    let tries = 0, cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          const list = await api.get("/me/assessments");
          const found = list.data.items.find(a => a.unlocked);
          setAid(found?.id);
          setStatus("paid");
        } else if (tries++ < 20) {
          setTimeout(() => !cancelled && poll(), 1500);
        } else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, nav]);

  return (
    <div><Nav />
      <div className="max-w-md mx-auto px-5 py-24 text-center fade-up">
        {status === "checking" && (
          <>
            <Loader2 className="w-10 h-10 text-[#E0A96D] mx-auto animate-spin mb-4" />
            <h1 className="font-serif text-3xl mb-2">Confirming your payment…</h1>
            <p className="text-slate-400">This usually takes a couple of seconds.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-4" />
            <h1 className="font-serif text-4xl mb-2">Unlocked</h1>
            <p className="text-slate-400 mb-6">Your complete DualQ is ready.</p>
            <button onClick={()=>nav(aid?`/results/${aid}`:"/dashboard")}
              className="px-6 py-3 rounded-xl bg-[#E0A96D] text-[#070C18] font-semibold hover:bg-[#F0C28B]"
              data-testid="see-profile-btn">
              See my complete DualQ
            </button>
          </>
        )}
        {(status === "timeout" || status === "error") && (
          <>
            <h1 className="font-serif text-3xl mb-2">Hmm, taking longer than usual</h1>
            <p className="text-slate-400 mb-4">If the charge went through, refresh your dashboard shortly.</p>
            <button onClick={()=>nav("/dashboard")} className="px-6 py-3 rounded-xl border border-slate-700 hover:border-slate-500">Back to dashboard</button>
          </>
        )}
      </div>
    </div>
  );
}
